import React, { useContext, useState } from "react";
import { Alert, LoadingOverlay } from "@mantine/core";

declare type statusType = "loading" | "success" | "error";

export interface IPortalContextProps {
  status: statusType;
  error?: string | null;
  notifications?: any;
}

const PortalContext = React.createContext<IPortalContextProps | null>(null);

const PortalProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [state, setState] = useState<IPortalContextProps>({
    status: "loading",
    error: null,
    notifications: null,
  });

  //const dataProvider = useDataProvider();
  //const dataProviderInstance = useMemo(() => dataProvider(), [dataProvider]);
  // const _notificationService = notificationService(dataProviderInstance);

  // useAuthenticatedApi(dataProviderInstance, () => {
  //   //TODO: load notifications
  // });

  return (
    <PortalContext.Provider value={state}>
      {state.status === "loading" ? (
        <LoadingOverlay visible={false} />
      ) : state.status === "error" ? (
        <Alert color="red" title="An error occured">
          {state.error}
        </Alert>
      ) : (
        children
      )}
    </PortalContext.Provider>
  );
};

const usePortal = () => {
  const state: IPortalContextProps = useContext(PortalContext) as any;

  const isLoading = state.status === "loading";
  const hasError = state.status === "error";
  const isSuccess = state.status === "success";
  const isLoaded = state.status === "success" && state.notifications;

  return {
    ...state,
    isLoading,
    hasError,
    isSuccess,
    isLoaded,
  };
};

export { PortalProvider, usePortal };
